import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Link, Typography } from "@mui/material";
// import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import SelectRecipient from '../../helpers/SelectRecipient';
import axios from "axios";
import { useContext, useState } from "react";
import SocketContext from './../../helpers/SocketContext';
import { errorToast } from "helpers/Notification";

function ProjectReportDetails({
  project,
  SetSelectedMenu,
  loggedUser,
  usedBudget,
  resources,
  linemanager,
  budget,
}) {
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [projectInfo, setProjectInfo] = React.useState(project);
  const [period, setPeriodState] = React.useState({
    startDate: moment().startOf("W"),
    endDate: moment().endOf("W"),
  });
  const [challengeModalOpen, setChallengeModalOpen] = React.useState(false);
  const [currentChallenge, setCurrentChallenge] = React.useState("");

  const [statusModalOpen, setStatusModalOpen] = React.useState(false);
  const [currentStatus, setCurrentStatus] = React.useState("");
  const [recipients, setRecipients] = React.useState([]);
  const [isSelectRecipientOpen, setIsSelectRecipientOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const socket = useContext(SocketContext);


  // const history = useHistory();

  const handleViewChallenge = (challenge) => {
    setCurrentChallenge(challenge);
    setChallengeModalOpen(true);
  };

  const handleCloseChallengeModal = () => {
    setChallengeModalOpen(false);
    setCurrentChallenge("");
  };

  const handleViewStatus = (status) => {
    setCurrentStatus(status);
    setStatusModalOpen(true);
  };

  const handleCloseStatusModal = () => {
    setStatusModalOpen(false);
    setCurrentStatus("");
  };

  useEffect(() => {
    // console.log("my linemanager: ", linemanager);
  }, [linemanager]);

  useEffect(() => {
    // console.log("used budget: ", usedBudget)
    // console.log("totAL budget: ", budget)
  }, [usedBudget, budget])

  useEffect(() => {
    if (open && linemanager) {
      setRecipients((prev) => {
        if (prev.length > 0 && prev[0]?.id === linemanager.id) return prev;
        return [linemanager, ...prev.filter(r => r.id !== linemanager.id)];
      });
    }
  }, [open, linemanager]);

  const handleSelectRecipients = (selectedEmployees) => {
    let updatedRecipients = selectedEmployees;
    if (linemanager) {
      updatedRecipients = [
        linemanager,
        ...selectedEmployees.filter(emp => emp.id !== linemanager.id)
      ];
    }
    setRecipients(updatedRecipients);
    setValue0("recipients", updatedRecipients);
    setIsSelectRecipientOpen(false);
  };

  const processData = (data) => {
    const filteredData = data.data.filter((item) => item.createdBy === loggedUser?.resourceId);

    const dateFilteredData = filteredData.filter((item) => {
      const reportDate = moment(item.date);
      return reportDate.isBetween(period.startDate, period.endDate, null, '[]');
    });

    setList(dateFilteredData);
    return { ...data, data: dateFilteredData };
  };

  const updatePeriod = (newPeriod) => {
    setPeriodState(newPeriod);
    processData({ data: list });
  };

  useEffect(() => {
    SetSelectedMenu({
      menu: "report",
      title: "Report Details",
    });
  }, []);

  const getWeekRange = (selectedDate) => {
    const date = moment(selectedDate);
    const startOfWeek = date.clone().startOf('isoWeek'); // Monday
    const endOfWeek = date.clone().endOf('isoWeek');     // Sunday
    return {
      startDate: startOfWeek.format("YYYY-MM-DD"),
      endDate: endOfWeek.format("YYYY-MM-DD"),
    };
  };

  const columnsDetails =

    [
      {
        name: "date",
        label: "Date",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            moment(value).format("DD/MM/yyyy") ?? "",
        },
      },
      {
        name: "Project.name",
        label: "Project Name",
      },
      {
        name: "budget",
        label: "Budget",
      },
      {
        name: "Project.impact",
        label: "Impact",
      },
      {
        name: "expense",
        label: "Used Budget",
        options: {
          filter: true,
          sort: true,
          customBodyRender: () => (
            <div dangerouslySetInnerHTML={{ __html: usedBudget }} />
          ),
        },
      },
      {
        name: "status",
        label: "Overall Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            const displayText = value
              ? value.length > 10
                ? value.substring(0, 10) + "..."
                : value
              : "";
            return (
              <Link
                href="#"
                onClick={(e) =>
                  e.preventDefault() ||
                  handleViewStatus(value)}
                sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
              >
                {displayText}
              </Link>
            );
          },
        },
      },
      {
        name: "challenges",
        label: "Challenges",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            const displayText = value
              ? value.length > 10
                ? value.substring(0, 10) + "..."
                : value
              : "";
            return (
              <Link
                href="#"
                onClick={(e) =>
                  e.preventDefault() ||
                  handleViewChallenge(value)}
                sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
              >
                {displayText}
              </Link>
            );
          },
        },
      },
      // {
      //   name: "Resource.names",
      //   label: "Prepared By",
      // },
      {
        name: "Project.status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <StatusLayout status={value ?? "not available"} />
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (v) => (
            <div className="flex items-center">
              <IconButton
                onClick={() => {
                  setOpen(2);
                  const obj = list.find(vx => vx.id === v);
                  const initialRecipients = linemanager ? [linemanager] : [];

                  // console.log("returned obj: ", obj);
                  setId(v);
                  setValue0('name', obj.name);
                  setValue0("projectId", obj.projectId);
                  setValue0("date", moment(obj.date).format("YYYY-MM-DD"));
                  setValue0("progress", obj.progress);
                  setValue0("status", obj.status);
                  setValue0("challenges", obj.challenges);
                  // setValue0("recipients", obj.recipients || []);
                  setValue0("recipients", initialRecipients);
                  setRecipients(initialRecipients);


                  // console.log(obj?.Resource.names);
                  // setRecipients(Array.isArray(obj.Resource) ? obj.Resource : [obj.Resource]);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Decorative SVG"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton onClick={() => { setId(v); setDeleteOpen(true); }}>
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Decorative SVG"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ];

  const handleFormSubmit = async (formData) => {
    setLoading(true);
    try {
      const response = await axios.post(
        open === 1 ? "/api/report/create/project-details" : `/api/report/update/project-details/${id}`
        , {
          ...formData,
        }
      );
      if (response.status) {
        const recipients = (formData.recipients || []).map(r => r.id || r);
        if (recipients.length > 0) {
          recipients.forEach((recipient) => {
            socket.emit("sendNotification", {
              message: `Project Report submitted by ${loggedUser?.Resource?.names} for the period ${formData.startDate} to ${formData.endDate}.`,
              type: "project_report_created",
              resourceId: loggedUser?.Resource?.id,
              receiverId: recipient,
            });
          });
        }
        onSuccess();
        setLoading(false);

        setOpen(0);
      } else {
        console.error("Error submitting form:", response.message);
        errorToast("Error submitting form: " + response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      errorToast("Error submitting form: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const setValue0 = (name, val) => {
    if (!name) return;

    setValue((v) => {
      v[name] = val;

      if (name === "date") {
        const { startDate, endDate } = getWeekRange(val);
        v["startDate"] = startDate;
        v["endDate"] = endDate;
      }

      return { ...v };
    });
  };

  const onSuccess = () => setCount((v) => v + 1);

  return (
    <div className="w-full mb-12 px-4">
      <Dialog
        open={challengeModalOpen}
        onClose={handleCloseChallengeModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div className={"flex items-center"}>
            <div className={"flex-grow font-bold text-lg"}>
              <Typography variant="h6" className="mb-3">Challenge Details</Typography>
            </div>
            <IconButton onClick={() => handleCloseChallengeModal(false)}>
              <img
                src={require("assets/icons/close.svg").default}
                alt={"close"}
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: currentChallenge }} />
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleCloseChallengeModal} color="primary">
            Close
          </Button> */}
        </DialogActions>
      </Dialog>

      <Dialog
        open={statusModalOpen}
        onClose={handleCloseStatusModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div className={"flex items-center"}>
            <div className={"flex-grow font-bold text-lg"}>
              <Typography variant="h6" className="mb-3">Status Details</Typography>
            </div>
            <IconButton onClick={() => handleCloseStatusModal(false)}>
              <img
                src={require("assets/icons/close.svg").default}
                alt={"close"}
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: currentStatus }} />
        </DialogContent>
      </Dialog>

      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/report/delete/project-details/${id}`}
      />
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/report/create/project-details" : `/api/report/update/project-details/${id}`}
        title={open === 1 ? "Add Project Report" : "Edit Report"}
        fields={[

          {
            name: "projectId",
            label: "Project names",
            value: projectInfo?.id,
            hidden: true,
            setValue: (val) => setValue0("projectId", val),
          },
          {
            name: "project",
            label: "Project name",
            value: projectInfo?.name,
            disabled: true,
          },
          {
            name: "date",
            label: "Date",
            type: "date",
            value: value["date"],
            // value: info?.date,
            required: true,
            setValue: (val) => setValue0("date", val),
          },
          {
            name: "startDate",
            label: "Start Date",
            type: "date",
            value: value["startDate"],
            hidden: true,
            // disabled: true,
          },
          {
            name: "endDate",
            label: "End Date",
            type: "date",
            value: value["endDate"],
            hidden: true,
            // disabled: true,
          },
          {
            name: "budget",
            label: "Budget",
            value: budget,
            disabled: true,
            required: true,
            setValue: (val) => setValue0("budget", val),
          },
          {
            name: "expense",
            label: "Used Budget",
            value: usedBudget,
            disabled: true,
            required: true,
            setValue: (val) => setValue0("expense", val),
          },
          {
            name: "impact",
            label: "Impact",
            value: projectInfo?.impact,
            disabled: true,
            required: true,
            setValue: (val) => setValue0("impact", val),
          },
          {
            name: "performance",
            label: "Performance",
            value: projectInfo?.completionPercentage ? String(projectInfo.completionPercentage).split('.')[0] : 0,
            disabled: true,
            required: true,
            setValue: (val) => setValue0("performance", val),
          },

          {
            name: "progress",
            label: "Progress",
            value: value["progress"] || 0,
            type: "number",
            required: true,
            setValue: (val) => setValue0("progress", val),
          },
          {
            name: "reportStatus",
            label: "Report Status",
            value: projectInfo?.status,
            disabled: true,
            required: true,
            // hiden: true,
            setValue: (val) => setValue0("reportStatus", val),
          },
          {
            name: "recipients",
            label: "Recipients",
            value: value["recipients"] || [],
            required: true,
            col: 12,
            render: () => (
              <div className="mb-3 row">
                <div className="col-md-10">
                  <TextField
                    value={(value["recipients"] || []).map(r => r.names).join(', ')}
                    fullWidth
                    margin="none"
                    onClick={() => setIsSelectRecipientOpen(true)}
                    multiline
                    InputProps={{ readOnly: true }}
                  />
                </div>
              </div>
            ),
            setValue: (val) => setValue0("recipients", val),
          },
          {
            name: "status",
            label: "Overall Status",
            value: value["status"],
            required: false,
            // type: "editor",
            type: "textarea",
            col: 12,
            setValue: (val) => setValue0("status", val),
          },
          {
            name: "challenges",
            label: "Challenges",
            value: value["challenges"],
            required: false,
            // type: "editor",
            type: "textarea",
            col: 12,
            setValue: (val) => setValue0("challenges", val),
          },




        ]}
        onSubmit={handleFormSubmit}

      />

      <SelectRecipient
        open={isSelectRecipientOpen}
        onClose={() => setIsSelectRecipientOpen(false)}
        confirm={handleSelectRecipients}
        selectedEmployees={recipients}
        resources={resources}
        settings={{ backgroundColorPrimary: '#1976d2' }}
      />
      <DatatableComponent
        onAddNew={() => {
          // console.log("project info: ", project)
          setOpen(1);
          const initialRecipients = linemanager ? [linemanager] : [];
          setRecipients(initialRecipients);
          setValue({
            projectId: projectInfo?.id,
            date: moment().format("YYYY-MM-DD"),
            startDate: moment().startOf("W").format("YYYY-MM-DD"),
            endDate: moment().endOf("W").format("YYYY-MM-DD"),
            recipients: initialRecipients,

          });
        }}
        search={false}
        viewColumns={false}
        pdf={true}
        excel={true}
        processData={(data) => {
          const filteredData = data.data.filter((item) => item.createdBy === loggedUser?.resourceId);
          const dateFilteredData = filteredData.filter((item) => {
            const reportDate = moment(item.date);
            return reportDate.isBetween(period.startDate, period.endDate, null, '[]');
          });
          setList(dateFilteredData);
          return { ...data, data: dateFilteredData };
        }}
        elevation={1}
        columns={columnsDetails}
        url={`/api/report/list?count=${count}&resourceId=${loggedUser?.resourceId}&period=${JSON.stringify(
          period
        )}&${project ? `project=${project?.id}` : undefined}`
        }
        title={
          <div className="flex gap-4 items-center">
            <div className="flex items-center gap-2">
              <label className="text-[#054163] font-medium">From</label>
              <input
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                type="date"
                value={
                  Date.parse(period?.startDate)
                    ? moment(period?.startDate).format("YYYY-MM-DD")
                    : ""
                }
                max={period.endDate}
                onChange={(e) => {
                  updatePeriod({
                    ...period,
                    startDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                  });
                }}
              />
            </div>

            <div className="flex items-center gap-2">
              <label className="text-[#054163] font-medium">To</label>
              <input
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                type="date"
                value={
                  Date.parse(period?.endDate)
                    ? moment(period?.endDate).format("YYYY-MM-DD")
                    : ""
                }
                min={moment(period?.startDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  updatePeriod({
                    ...period,
                    endDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                  });
                }}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectReportDetails);
